import { get, patch, post, put } from './../Config/config';

export const Organization = {
    get: (data) => get('/organizations', { params: data }),
    sync: () => get('/organizations/sync'),
    // Add method to get organization details by ID
    getById: (id) => get(`/organizations/${id}`),
    // Add method to get members by organization ID
    getMembers: (organizationId) => get(`/organizations/${organizationId}/members`),
    // Add update method
    update: (id, data) => patch(`/organizations/${id}`, data),
    // Add method to create a new organization
    add: (data) => post('/organizations/store', data),
}